import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpOperatorFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { ExpArgumentOperandFactory } from "./ExpArgumentOperand";
// @ts-ignore noUnusedLocals
import { ExpArgumentOperandGroupFactory } from "./ExpArgumentOperandGroup";
// @ts-ignore noUnusedLocals
import { ExpAdditionalDataFactory } from "./ExpAdditionalData";
// @ts-ignore noUnusedLocals
import { ExpSourceOperandTypeFactory } from "./ExpSourceOperandType";
// @ts-ignore noUnusedLocals
import { ExpOperatorSummaryFormatFactory } from "./ExpOperatorSummaryFormat";
// @ts-ignore noUnusedLocals
import { ExpOperatorOutputFactory } from "./ExpOperatorOutput";

/**
 * 
 * @export
 * @interface ExpOperator
 */

export class ExpOperatorFactory {}
_ExpOperatorFactory = ExpOperatorFactory;
_defineProperty(ExpOperatorFactory, "FromJSON", function (json) {
  return _ExpOperatorFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpOperatorFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'id': json['id'],
    'label': json['label'],
    'selectorLabel': json['selectorLabel'],
    'sortPriority': json['sortPriority'],
    'description': json['description'],
    'roleID': json['roleID'],
    'groupID': json['groupID'],
    'output': json['output'] === null || json['output'] === undefined ? json['output'] : ExpOperatorOutputFactory.FromJSON(json['output']),
    'sourceOperandName': json['sourceOperandName'],
    'sourceOperandLabel': json['sourceOperandLabel'],
    'sourceOperandTypes': json['sourceOperandTypes'] === null || json['sourceOperandTypes'] === undefined ? json['sourceOperandTypes'] : json['sourceOperandTypes'].map(ExpSourceOperandTypeFactory.FromJSON),
    'sourceOperandExecutionFlags': json['sourceOperandExecutionFlags'] === null || json['sourceOperandExecutionFlags'] === undefined ? json['sourceOperandExecutionFlags'] : json['sourceOperandExecutionFlags'],
    'argumentOperands': json['argumentOperands'] === null || json['argumentOperands'] === undefined ? json['argumentOperands'] : json['argumentOperands'].map(ExpArgumentOperandFactory.FromJSON),
    'argumentOperandGroups': json['argumentOperandGroups'] === null || json['argumentOperandGroups'] === undefined ? json['argumentOperandGroups'] : json['argumentOperandGroups'].map(ExpArgumentOperandGroupFactory.FromJSON),
    'additionalData': json['additionalData'] === null || json['additionalData'] === undefined ? json['additionalData'] : ExpAdditionalDataFactory.FromJSON(json['additionalData']),
    'summaryOutputFormats': json['summaryOutputFormats'] === null || json['summaryOutputFormats'] === undefined ? json['summaryOutputFormats'] : json['summaryOutputFormats'].map(ExpOperatorSummaryFormatFactory.FromJSON),
    'editorConfiguration': json['editorConfiguration'] === null || json['editorConfiguration'] === undefined ? json['editorConfiguration'] : json['editorConfiguration'],
    'integrationConfiguration': json['integrationConfiguration'] === null || json['integrationConfiguration'] === undefined ? json['integrationConfiguration'] : json['integrationConfiguration'],
    'deprecated': json['deprecated'],
    'operatorExecutionFlags': json['operatorExecutionFlags'] === null || json['operatorExecutionFlags'] === undefined ? json['operatorExecutionFlags'] : json['operatorExecutionFlags'],
    'internalOnly': json['internalOnly']
  };
});
_defineProperty(ExpOperatorFactory, "ToJSON", function (value) {
  return _ExpOperatorFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpOperatorFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'id': value.id,
    'label': value.label,
    'selectorLabel': value.selectorLabel,
    'sortPriority': value.sortPriority,
    'description': value.description,
    'roleID': value.roleID,
    'groupID': value.groupID,
    'output': ExpOperatorOutputFactory.ToJSON(value.output),
    'sourceOperandName': value.sourceOperandName,
    'sourceOperandLabel': value.sourceOperandLabel,
    'sourceOperandTypes': value.sourceOperandTypes === undefined ? undefined : value.sourceOperandTypes.map(ExpSourceOperandTypeFactory.ToJSON),
    'sourceOperandExecutionFlags': value.sourceOperandExecutionFlags,
    'argumentOperands': value.argumentOperands === undefined ? undefined : value.argumentOperands.map(ExpArgumentOperandFactory.ToJSON),
    'argumentOperandGroups': value.argumentOperandGroups === undefined ? undefined : value.argumentOperandGroups.map(ExpArgumentOperandGroupFactory.ToJSON),
    'additionalData': ExpAdditionalDataFactory.ToJSON(value.additionalData),
    'summaryOutputFormats': value.summaryOutputFormats === undefined ? undefined : value.summaryOutputFormats.map(ExpOperatorSummaryFormatFactory.ToJSON),
    'editorConfiguration': value.editorConfiguration,
    'integrationConfiguration': value.integrationConfiguration,
    'deprecated': value.deprecated,
    'operatorExecutionFlags': value.operatorExecutionFlags,
    'internalOnly': value.internalOnly
  };
});
//# sourceMappingURL=ExpOperator.js.map
